// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"7146d380","226":"c8f5981a","266":"c7c4f9fc","329":"f3ee2c81","421":"91a3176e","437":"63797f42","442":"8492b2eb","594":"72da2e1c","609":"c9b3574a","737":"cae2f447","910":"2abd7857"}[chunkId] + ".chunk.js";
};